import { RichText } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

type RichTextEntry = Parameters<typeof kontentAiDataMapping.rich_text>[0];

export default {
  component: () => RichText,
  mapEntryToProps: (entry: RichTextEntry) =>
    kontentAiDataMapping.rich_text(entry),
};
